import { AddressViewModel } from '@models/common.models';
import { OptionsViewModel } from '@models/common.models';
export interface VendorViewModel {
  companyName: string;
  id: number;
  emailAddress: string;

  dbaName: string;
  vendorGroup: OptionsViewModel;
  businessPhone: string;
  businessFax: string;
  afterHoursPhone: string;

  ownerName: string;
  managerName: string;

  address?: AddressViewModel;
  apName: string;

  parentId: number;
  vendorType: OptionsViewModel;
  vendorStatus: OptionsViewModel;
  licenseNumber: string;
  licenseExpiration?: Date;

  taxId: string;
  has1099?: boolean;
  w9Status: OptionsViewModel;

  liabilityExpiration?: Date;
  liabilityWaiver?: boolean;
  sdiExpiration?: Date;
  sdiWaiver?: boolean;
  hourlyRate: number;
  overtimeRate: number;
  weekendRate: number;
  emergencyRate: number;
  secondWorkerRate: number;
  diagnosticRate: number;
  authoLimit: number;

  agreementType: OptionsViewModel;
  agreementDate: Date;
  dispatchLimitPermanent: number;
  dispatchLimitTemp: number;
  dispatchLimitTempExpiration: Date;
  suspendedUntil: Date;

  statReport?: boolean;
  autoRerating?: boolean;
  reportCard?: boolean;

  vendorPortal?: boolean;
  onlineAutho?: boolean;
  noBidding?: boolean;

  invoicePricing?: number;
  vendorRelations: number;
  customerRelations: number;

  vendorTrades?: Array<TradeViewModel>;
  coveredZips?: string[];

  w9SignedDate: Date;
  w9TaxYear: string;

  weekdayHours: BusinessHours;
  saturdayHours: BusinessHours;
  sundayHours: BusinessHours;
  holidayHours: BusinessHours;

  converted: boolean;
}

export enum VendorDocumentExpire {
  LiabilityExpiration = 1,
  WorkersCompExpiration = 2,
  LicenseExpiration = 3
}

export interface VendorSearchViewModel {
  address: AddressViewModel;
  dispatchCount?: number;
  email: string;
  group: string;
  id: number;
  isLiabilityWaived: boolean;
  isSuspended: boolean;
  name: string;
  phoneNumber: string;
  rating?: number;
  redispatchPercentage: number;
  // trades
  vendorAverageInvoiceAmount?: number;
  vendorGroupAverageInvoiceAmount?: number;
}

export interface VendorPriceAgreement {
  name: string;
  standardVendorGroupPrice: number;
  vendorModifiedPrice: number | null;
  paymentType: PriceAgreementPaymentType;
}

export enum PriceAgreementPaymentType {
  FlatRate = 'flatRate',
  TM = 'timeAndMaterials'
}

export class VendorModel implements VendorViewModel {
  invoicePricing?: number;
  vendorRelations: number;
  customerRelations: number;

  companyName: string;
  id: number;
  emailAddress: string;

  dbaName: string;
  vendorGroup: OptionsViewModel;
  businessPhone: string;
  businessFax: string;
  afterHoursPhone: string;

  address?: AddressViewModel;

  vendorType: OptionsViewModel;
  liabilityExpiration: Date;
  liabilityWaiver?: boolean;
  hourlyRate: number;
  overtimeRate: number;
  weekendRate: number;
  emergencyRate: number;
  secondWorkerRate: number;
  diagnosticRate: number;

  vendorStatus: OptionsViewModel;
  sdiExpiration: Date;
  sdiWaiver?: boolean;
  authoLimit: number;

  licenseNumber: string;
  licenseExpiration: Date;
  agreementDate: Date;
  dispatchLimitPermanent: number;
  dispatchLimitTemp: number;
  dispatchLimitTempExpiration: Date;

  apName: string;
  taxId: string;
  has1099?: boolean;
  agreementType: OptionsViewModel;
  suspendedUntil: Date;

  parentId: number;
  w9Status: OptionsViewModel;
  statReport?: boolean;
  vendorPortal?: boolean;
  autoRerating?: boolean;
  onlineAutho?: boolean;
  reportCard?: boolean;
  noBidding?: boolean;

  ownerName: string;
  managerName: string;

  vendorTrades?: Array<TradeViewModel>;

  w9SignedDate: Date;
  w9TaxYear: string;

  weekdayHours: BusinessHours;
  saturdayHours: BusinessHours;
  sundayHours: BusinessHours;
  holidayHours: BusinessHours;

  converted: boolean;
}

export interface BusinessHours {
  startHour?: number;
  startMinute?: number;
  startPeriod?: string;
  endHour?: number;
  endMinute?: number;
  endPeriod?: string;
}

export interface TradeViewModel {
  vendorId: number;
  tradeId: number; // public short TradeCd { get; set; }
  reactivateDate?: Date;
  deactivateDate?: Date;
  authorizedAmountOverride?: number; // public decimal? AuthoLimitAm { get; set; }
  hourlyAmountOverride?: number; // public decimal? HourlyAm { get; set; }
  dispatchLimit?: number; // public short? DispatchLimitQt { get; set; }
  temporaryDispatchLimitOverride?: number; // public short? DispatchLimitTempQt { get; set; }
  temporaryDispatchLimitOverrideExpiresDt?: Date;
  tradeActiveStatus: boolean;
  tradeDeactivatedStatus: boolean; // this boolean is used to know if a trade is removed (soft deletedd)
  markupPercent?: number;
}

export interface TradeOptionsViewModel extends OptionsViewModel {
  tradeAnalysisId: number;
  tradeAnalysisName: string;
}

export interface TradeListItemViewModel {
  tradeOption: TradeOptionsViewModel;
  tradeVM: TradeViewModel;
}

export interface PriceAgreementViewModel {
  hourly: boolean;
  item: string;
  itemId: number;
  standardPrice: number;
  vendorPrice: number;
}

export interface VendorSelectionModel {
  afterHoursPhone: string;
  avg: number;
  fax: string;
  id: number;
  month: number;
  phone: string;
  rating: number;
  today: string;
  trip: string;
  vendor: string;
}

export interface CviOptionsViewModel {
  id: number;
  value: string;
  order?: string;
  isBrandable: boolean;
}

export interface ZipCountyOptionsViewModel {
  countyName: string;
  cities: ZipCityViewModel[];
}

export interface ExcludedZipViewModel {
  vendorId: number;
  tradeId: number;
  zip: string;
  tripCharge?: number;
}

export interface ZipCityViewModel {
  cityName: string;
  zipCodes: string[];
}

export enum VendorPacketEventType {
  PacketSent = 'Packet Sent',
  PacketReceipt = 'Packet Receipt',
  PacketDataEntry = 'Packet Data Entry'
}

export interface VendorPacketEventViewModel {
  vendorProcurementId: number;
  vendorId: number;
  packetEventName: string;
  packetEventDate?: Date;
  packetEventEmployee?: OptionsViewModel;
}



// WEBPACK FOOTER //
// ./src/_models/Vendor.ts